import React, { useEffect, useRef, useState } from "react";
import { withSnackbar } from "notistack";
// Data Tables
import jQuery from "jquery";
import "datatables.net-bs4";
import "datatables.net-buttons-bs4";
import "datatables.net-buttons/js/buttons.html5";
import "datatables.net-buttons/js/buttons.print";
import "datatables.net-buttons/js/buttons.flash";
import "pdfmake/build/pdfmake";
import "pdfmake/build/vfs_fonts";

import Loader from "components/Custom/Loader";
import AutoComplete from "components/Custom/AutoComplete";
import TxtBox from "components/Custom/TxtBox";
import Btn from "components/Custom/Btn";

import {
  LABELS,
  ERRORS,
  WARNINGS,
  SUCCESS,
  CONFIRMS,
  TITLES,
  SUB_TITLES,
} from "common/labels";
import { DateFunctions } from "common//datefunctions";
import { COMMON_JS } from "common/scripts";
import { ApiReports } from "apihandlers//reports";
import ExcelGrid from "components/Custom/ExcelGrid";
import { NOTIFY } from "common/config";
const ApiReportsHandler = new ApiReports();

const $ = jQuery;

const VehiclesList = (props: any) => {
  const { setDashMenu } = props;

  const [loading, setLoading] = useState(false);
  const [chartData, setChartData] = useState<any>({});
  const [rows, setRows] = useState<any>(null);
  const [mandatoryResults, setMandatoryResults] = useState<any[]>([]);
  const columns = [
    {
      key: "slNo",
      name: LABELS.SL_NO,
      width: "10%",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
      headerAlign: "center",
    },
    {
      key: "vehicleNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_NO,
      width: "15%",
    },
    {
      key: "vehicleMake",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_MAKE,
      width: "10%",
    },
    {
      key: "vehicleModel",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_MODEL,
      width: "10%",
    },
    {
      key: "engineNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ENGINE_NO,
      width: "10%",
    },
    {
      key: "chassisNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.CHASSIS_NO,
      width: "10%",
    },
    {
      key: "purchaseDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PURCHASE_DATE,
      width: "10%",
    },
    {
      key: "ownerName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.OWNER_NAME,
      width: "10%",
    },
    {
      key: "driverUserName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.USER_NAME,
      width: "10%",
    },
    {
      key: "permitNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PERMIT_NO,
      width: "10%",
    },
    {
      key: "permitValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PERMIT_UPTO,
      width: "10%",
    },
    {
      key: "fcValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FITNESS_UPTO,
      width: "10%",
    },
    {
      key: "insuranceValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INSURENCE_UPTO,
      width: "10%",
    },
    {
      key: "emissionValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EMMISSION_VALIDITY,
      width: "10%",
    },
    {
      key: "fastagNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FAST_TAG_NO,
      width: "10%",
    },
    {
      key: "dieselCardNumber",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FUEL_CARD_NO,
      width: "10%",
    },
    {
      key: "gpsImei",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.GPS_IMEI,
      width: "10%",
    },
    {
      key: "fuelTypes",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FUEL_TYPE,
      width: "10%",
    },
    {
      key: "registrationValidity",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.REGISTRATION_VALIDITY,
      width: "10%",
    },
    {
      key: "emissionNorms",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.EMISSION_NORMS,
      width: "10%",
    },
    {
      key: "rcStatus",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.RC_STATUS,
      width: "10%",
    },
    {
      key: "manufacturingYear",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MANUFACTURING_YEAR,
      width: "10%",
    },

    {
      key: "insuranceStartDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.INSURENCE_FROM,
      width: "10%",
    },
    {
      key: "fitnessStartDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.FITNESS_FROM,
      width: "10%",
    },
    {
      key: "permitStartDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.PERMIT_FROM,
      width: "10%",
    },
    {
      key: "roadTaxStartDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROADTAX_FROM,
      width: "10%",
    },
    {
      key: "roadTaxEndDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.ROADTAX_UPTO,
      width: "10%",
    },
    {
      key: "speedLimiterEndDate",
      type: "date",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.SPEED_LIMIT_UPTO,
      width: "10%",
    },
    {
      key: "vehicletypeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.VEHICLE_TYPE,
      width: "10%",
    },
    {
      key: "axleName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.AXLE_NAME,
      width: "10%",
    },
    {
      key: "bodyTypeName",
      type: "text",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.BODY_TYPE,
      width: "10%",
    },
    {
      key: "minPassingTon",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MINIMUM_PASSING_TON,
      width: "10%",
    },
    {
      key: "maxPassingTon",
      type: "number",
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.MAXIMUM_PASSING_TON,
      width: "10%",
    },
    {
      key: "isAttached",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.IS_ATTACHED,
      width: "10%",
    },
    {
      key: "isHypothicated",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      name: LABELS.IS_HYPOTHICATED,
      width: "10%",
    },

    {
      key: "activeStatus",
      name: LABELS.ACTIVE,
      width: "6%",
      type: "dropdown",
      filters: [
        {
          id: "yes",
          name: "Yes",
        },
        {
          id: "no",
          name: "No",
        },
      ],
      editable: false,
      sortable: true,
      searchable: true,
      align: "center",
    },
  ];

  const loadChart = () => {
    const fromDt = (document.getElementById("fromDt") as HTMLInputElement)
      .value;
    const toDt = (document.getElementById("toDt") as HTMLInputElement).value;
    const args = {
      fromDt,
      toDt,
      reportType: "excel",
    };
    let errors = [];
    if (fromDt == "") {
      errors.push({
        id: "fromDt",
        msg:
          "<span class='bold'>" +
          LABELS.FROM_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    if (toDt == "") {
      errors.push({
        id: "toDt",
        msg:
          "<span class='bold'>" +
          LABELS.TO_DATE +
          "</span> " +
          WARNINGS.IS_A_REQUIRED_FIELD,
      });
    }
    setMandatoryResults(errors);
    if (errors.length > 0) {
      COMMON_JS.showNotify(
        props,
        NOTIFY.WARNING,
        WARNINGS.PLEASE_CHECK_FORM_ERRORS
      );
      return;
    }
    // if ($.fn.dataTable.isDataTable("#reportGrid")) {
    //   let table = $("#reportGrid").DataTable();
    //   table.destroy();
    // }
    // if ($("#reportGrid")) {
    //   $("#reportGrid").empty();
    // }
    setChartData(null);
    setRows(null);
    ApiReportsHandler.getVehicleReport(args).then((res) => {
      // console.log("getVehicleReport:", args);
      const response: any = res.response;
      const { status } = res;
      if (status === 200) {
        const list = response.rows;
        for (let i = 0; i < response.rows.length; i++) {
          response.rows[i]["slNo"] = i + 1;
          if (list[i]["isAttached"]) {
            list[i]["isAttached"] = "Yes";
          } else {
            list[i]["isAttached"] = "No";
          }
          if (list[i]["isHypothicated"]) {
            list[i]["isHypothicated"] = "Yes";
          } else {
            list[i]["isHypothicated"] = "No";
          }
          if (list[i]["activeStatus"]) {
            list[i]["activeStatus"] = "Yes";
          } else {
            list[i]["activeStatus"] = "No";
          }
        }
        setChartData(response);
        setRows(response.rows);
      }
    });
  };

  return (
    <React.Fragment>
      <div className="pageInfo">
        <ul className="breadcrumbs">
          <li onClick={() => setDashMenu("")}>{LABELS.HOME}</li>
          <li className="dim">{" / "}</li>
          <li onClick={() => props.setDashMenu(LABELS.HOME)}>
            {LABELS.REPORTS}
          </li>
          <li className="dim">{" / "}</li>
          <li className="active">{TITLES.VEHICAL_LIST}</li>
        </ul>
        <h4>{TITLES.VEHICAL_LIST}</h4>
        <p className="SubTitles">{SUB_TITLES.VEHICAL_LIST}</p>
      </div>
      {loading ? (
        <div className="flexCenter" style={{ minHeight: 450 }}>
          <Loader />
        </div>
      ) : (
        <div className="hChart">
          <div id="chartForm">
            <div
              className="formGroup"
              style={{
                display: "flex",
                marginTop: 5,
                marginBottom: 20,
              }}
            >
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.FROM_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="fromDt"
                  defaultValue={DateFunctions.getDate(
                    "today",
                    "from",
                    "YYYY-MM-DD"
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  marginRight: 15,
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                <label
                  style={{
                    fontWeight: "500",
                    fontSize: 14,
                    marginTop: 6,
                    marginRight: 8,
                  }}
                >
                  {LABELS.TO_DATE}
                </label>
                <TxtBox
                  type={"date"}
                  id="toDt"
                  defaultValue={DateFunctions.getDate(
                    "thismonth",
                    "to",
                    "YYYY-MM-DD"
                  )}
                />
              </div>
              <div
                style={{
                  display: "flex",
                }}
              >
                <Btn
                  text={LABELS.LOAD}
                  onClick={loadChart}
                  loading={!chartData}
                />
              </div>
            </div>
          </div>
          {mandatoryResults.length > 0 && (
            <div className="mandatoryBox">
              <ul>
                {mandatoryResults.map((m) => {
                  return (
                    <li>
                      <span dangerouslySetInnerHTML={{ __html: m.msg }} />
                    </li>
                  );
                })}
              </ul>
            </div>
          )}
          {rows && (
            <ExcelGrid
              id={LABELS.VEHICAL_LIST}
              height={window.innerHeight * 0.8}
              cols={columns}
              rows={rows}
              exportOption={true}
              newRowOption={false}
              exportName={LABELS.VEHICAL_LIST}
            />
          )}
        </div>
      )}
    </React.Fragment>
  );
};

export default withSnackbar(VehiclesList);
